import { db } from "../../firebase/Config";
import { fetchMenus } from "../menus";

export const obtenerDatosEmpresa = async (empresaId) => {
  try {
    const empresaSnapshot = await db
      .collection("empresas")
      .doc(empresaId)
      .get();

    if (empresaSnapshot.exists) {
      return empresaSnapshot.data();
    } else {
      console.log("No se encontraron datos en la colección empresas.");
      return null;
    }
  } catch (error) {
    console.error(
      "Error al obtener datos de la empresa desde Firebase:",
      error,
    );
    throw error;
  }
};

export const obtenerPerfilesCreados = async () => {
  try {
    const perfilesSnapshot = await db
      .collection("configuraciones_generales")
      .doc("perfiles")
      .collection("items")
      .get();

    return perfilesSnapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        perfil: data.perfil || data.nombre || doc.id,
        ...data,
      };
    });
  } catch (error) {
    console.error("Error al obtener perfiles creados:", error);
    throw error;
  }
};

// End of read-only services
/**
 * Funcion que obtiene los perfiles de la coleccion perfiles
 * @perfilId {string} id del perfil a obtener
 * @returns {object} datos del perfil
 */
export const obtenerPerfilPorId = async (perfilId) => {
  try {
    const perfilSnapshot = await db
      .collection("configuraciones_generales")
      .doc("perfiles")
      .collection("items")
      .doc(perfilId)
      .get();

    if (perfilSnapshot.exists) {
      return perfilSnapshot.data().accesos;
    } else {
      console.log("No se encontraron datos en la colección perfiles.");
      return [];
    }
  } catch (error) {
    console.error("Error al obtener datos del perfil desde Firebase:", error);
    throw error;
  }
};
